<template>
  <div class="display">
    <div class="f-tar">
      <Button @click="$router.push('/host/index/audit/list')">返回</Button>
    </div>
    <div v-if="info && info.length">
      <div v-for="(item, index) in info" :key="'contact-' + index">
        <div class="item">
          <div class="item-l">提交时间：</div>
          <div class="item-r">{{ item.changeTime | moment("YYYY/MM/DD HH:mm:ss")}}</div>
        </div>
        <div class="item">
          <div class="item-l">审核状态：</div>
          <div class="item-r">
            <span v-if="item.status === 0" style="color: red;">尚未审核</span>
            <span v-if="item.status === 1" style="color: blue;">审核通过</span>
            <span v-if="item.status === -1" style="color: red;">审核未通过</span>
          </div>
        </div>
        <div class="item">
          <div class="item-l">操作状态：</div>
          <div class="item-r">
            <span style="margin-right: 10px;color: #1890ff;" v-if="item.commandId === 1">新增</span>
            <span style="margin-right: 10px;" v-if="item.commandId === 2">修改</span>
            <span style="margin-right: 10px;color: #f00;" v-if="item.commandId === 3">删除</span>
          </div>
        </div>
        <div class="item">
          <div class="item-l">姓名：</div>
          <div
            class="item-r"
            :class="{editMode:  (item.original && item.original.name !== item.name)}"
          >{{ item.name || 'N/A'}}</div>
        </div>
        <div class="item">
          <div class="item-l">职务：</div>
          <div
            class="item-r"
            :class="{editMode:  (item.original && item.original.jobTitle !== item.jobTitle)}"
          >{{ item.jobTitle || 'N/A'}}</div>
        </div>
        <div class="item">
          <div class="item-l">类别：</div>
          <div
            class="item-r"
            :class="{editMode:  (item.original && item.original.linkType !== item.linkType)}"
          >{{ item.linkType || 'N/A'}}</div>
        </div>
        <div class="item">
          <div class="item-l">手机：</div>
          <div
            class="item-r"
            :class="{editMode:  (item.original && item.original.mob !== item.mob)}"
          >{{ item.mob || 'N/A'}}</div>
        </div>
        <div class="item">
          <div class="item-l">邮箱：</div>
          <div
            class="item-r"
            :class="{editMode:  (item.original && item.original.email !== item.email)}"
          >{{ item.email || 'N/A'}}</div>
        </div>
        <div class="item">
          <div class="item-l">电话：</div>
          <div
            class="item-r"
            :class="{editMode:  (item.original && item.original.tel !== item.tel)}"
          >{{ item.tel || 'N/A'}}</div>
        </div>
        <div class="item">
          <div class="item-l">邮寄地址：</div>
          <div
            class="item-r"
            :class="{editMode:  (item.original && item.original.address !== item.address)}"
          >{{ item.address || 'N/A'}}</div>
        </div>
        <div class="item">
          <div class="item-l">传真：</div>
          <div
            class="item-r"
            :class="{editMode:  (item.original && item.original.fax !== item.fax)}"
          >{{ item.fax || 'N/A'}}</div>
        </div>
        <div class="f-tac" v-if="item && item.status !== 1">
          <Button @click="pass(item)" style="margin: 0 10px;" type="primary">通过审核</Button>
          <Button @click="unpass(item)" style="margin: 0 10px;" type="primary">不通过</Button>
        </div>
        <div class="f-tac" v-if="item && (item.status === 1 && item.syncStatus === 2)">
          <Button @click="asyncHandle">重新同步</Button>
        </div>
        <div class="line"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "host-audit-info-contact",
  data() {
    return {
      query: null,
      info: null,
      info2: null
    };
  },
  created() {
    this.query = this.$route.query;
    this.init();
  },
  computed: {
    ...mapGetters({
      joinInfo: "loginModule/getJoinInfo"
    }),
    cityBool() {
      let bool = false;
      if (this.info && this.info.original) {
        const cityStr = this.info.province + this.info.city + this.info.county;
        const cityStr2 =
          this.info.original.province +
          this.info.original.city +
          this.info.original.county;
        if (cityStr !== cityStr2) {
          bool = true;
        }
      }
      return bool;
    }
  },
  methods: {
    ...mapActions({
      getContactDownByRecord: "hostAuditModule/getContactDownByRecord",
      editContactDownAudit: "hostAuditModule/editContactDownAudit",
      reSync: "hostAuditModule/reSync"
    }),
    async init() {
      this.info = await this.getContactDownByRecord(this.$route.query.id);
    },
    async pass(item) {
      // 通过审核
      const opt = {
        id: item.recordId,
        status: 1
      };
      const bool = await this.editContactDownAudit(opt);
      if (bool && bool.successed) {
        this.$Message.success("操作成功");
        // this.$router.push("/host/index/audit/list");
        this.init();
      } else {
        if (bool.errors.description) {
          this.$Message.error(bool.errors.description);
        } else {
          this.$Message.error("操作失败，请重新尝试");
        }
      }
    },
    async unpass(item) {
      // 不通过审核
      const opt = {
        id: item.recordId,
        status: -1
      };
      const bool = await this.editContactDownAudit(opt);
      if (bool && bool.successed) {
        this.$Message.success("操作成功");
        // this.$router.push("/host/index/audit/list");
        this.init();
      } else {
        if (bool.errors.description) {
          this.$Message.error(bool.errors.description);
        } else {
          this.$Message.error("操作失败，请重新尝试");
        }
      }
    },
    async asyncHandle() {
      // 重新同步
      const bool = await this.reSync({ exchangeId: this.info.exchangeId });
      if (bool && bool.successed) {
        this.$Message.success("操作成功");
        this.init();
      } else {
        if (bool.errors.description) {
          this.$Message.error(bool.errors.description);
        } else {
          this.$Message.error("操作失败，请重新尝试");
        }
      }
    }
  }
};
</script>

<style scoped lang="scss">
.display {
  padding: 20px 40px 40px;
  font-size: 14px;
  background: #fff;
  margin: 30px;
  color: #333;
  min-width: 800px;
  min-height: 500px;
  .item {
    display: flex;
    margin-bottom: 18px;
    &-l {
      width: 200px;
      text-align: right;
    }
    &-r {
      flex: 1;
    }
  }
}
.logo-example {
  display: flex;
  &-box {
    display: flex;
    flex-wrap: wrap;
    flex: 1;
  }
  &-item {
    display: flex;
    width: 100%;
    p {
      font-size: 12px;
      color: #808080;
      padding-left: 10px;
    }
    &.z-large-s {
      img {
        width: 40px;
        height: 40px;
        border: 1px solid #bfbfbf;
      }
      p {
        line-height: 40px;
      }
    }
    &.z-large-m {
      img {
        width: 30px;
        height: 30px;
        border: 1px solid #bfbfbf;
      }
      p {
        line-height: 30px;
      }
    }
    &.z-large-l {
      img {
        width: 20px;
        height: 20px;
        border: 1px solid #bfbfbf;
      }
      p {
        line-height: 20px;
      }
    }
  }
}
.editMode {
  color: red !important;
}
.edit {
  border-color: red !important;
}
.line {
  height: 1px;
  background: #ccc;
  margin: 20px 0;
}
</style>
